import { loadModalContent } from "app/modules/cms/service/cms-service";
import { isEmptyObject } from "app/shared/util/method-util";
import { ModalConstants, Step } from "../../utils/step-engine-constants";
import { setShowErrorModal } from "../store/step-engine-dispatchs";

export const manageModal = (cmsContent, behaviors) => async (dispatch) => {
  const { showModal } = behaviors || {};
  if (showModal) {
    if (!cmsContent[ModalConstants[showModal]]) {
      await dispatch(loadModalContent(ModalConstants[showModal]));
    }
    dispatch(setShowErrorModal(true));
  }
};

export const behaviorStepExist = (cmsContent, currentStep, behaviorName: string): boolean => {
  if (cmsContent && currentStep) {
    return (
      !isEmptyObject(cmsContent[Step[currentStep]]?.behaviors) &&
      cmsContent[Step[currentStep]]?.behaviors?.[behaviorName]
    );
  }
  return false;
};

export const nextBehaviorExist = (behaviors, behaviorName: string): boolean => {
  if (behaviors) {
    return (
      !isEmptyObject(behaviors) && behaviors[behaviorName]
    );
  }
  return false;
};
